<template>
  <div class="nav_menu">
    <div class="title">热门法律领域</div>
    <div class="menu_list">
      <div class="menu_item between" v-for="(item, index) in list" :key="index">
        <div class="FontSize16 ellipsis">
          <span @click="tojjlist(item)">{{ item.cat_name }}</span>
          <span
            class="FontSize14"
            style="color: #999"
            v-if="item.children[0]"
            @click="tojjlist(item.children[0])"
          >
            / {{ item.children[0].cat_name }}
          </span>
          <span
            class="FontSize14"
            style="color: #999"
            v-if="item.children[1]"
            @click="tojjlist(item.children[1])"
          >
            / {{ item.children[1].cat_name }}
          </span>
          <div class="menu_child" v-if="item.children">
            <div
              class="child_list"
              v-for="(chitem1, ch1index) in item.children.slice(0, 2)"
              :key="ch1index"
            >
              <div
                class="child_title text_hover_shou"
                @click="tojjlist(chitem1)"
              >
                {{ chitem1.cat_name }} >
              </div>
              <div class="child_tag flex_start wrap">
                <div
                  class="text_hover_shou"
                  v-for="(child_item, child_index) in chitem1.children"
                  :key="child_index"
                  @click="tojjlist(child_item)"
                >
                  {{ child_item.cat_name }}
                </div>
              </div>
            </div>
            <div class="quick_entry between">
              <!-- <div class="text_hover_shou">
                <div>
                  <img src="~assets/home/navmenuicon1.png" />
                </div>
                <div>刑事辩护在线咨询</div>
              </div>

              <div class="text_hover_shou">
                <div>
                  <img src="~assets/home/navmenuicon2.png" />
                </div>
                <div>刑事辩护在线律师</div>
              </div>

              <div class="text_hover_shou">
                <div>
                  <img src="~assets/home/navmenuicon3.png" />
                </div>
                <div>刑事辩护案件委托</div>
              </div>

              <div class="text_hover_shou">
                <div>
                  <img src="~assets/home/navmenuicon4.png" />
                </div>
                <div>刑事辩护法律知识</div>
              </div> -->
            </div>
          </div>
        </div>
        <div><svg-icon icon-class="jt_right"></svg-icon></div>
      </div>
    </div>
    <div class="MORE text_hover_shou">MORE+</div>
  </div>
</template>

<script>
export default {
  name: "lvNavMenu",
  props: ["list"],
  components: {},
  data() {
    return {
      current_swiper: 0,
    };
  },
  methods: {
    swiperchange(e) {
      this.current_swiper = e;
    },
    changeswipe(e) {
      this.$refs.elswipe.setActiveItem(e);
    },
    tojjlist(item) {
      this.$store.commit("laws/upfljjxx", { name: item.cat_name, id: item.id });
      this.$router.push({
        path: "/laws/speciallist",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.nav_menu {
  padding-bottom: 15px;
  background-color: #fff;
  position: relative;

  > .title {
    height: 46px;
    line-height: 46px;
    text-align: center;
    font-size: 22px;
    color: #fff;
    background-image: url("~assets/home/blue_line_bg.png");

    width: 100%;
  }
  .menu_list {
    padding: 10px 0;
    color: #333;
    height: auto;

    .menu_item {
      padding: 8px 29px;
      span {
        cursor: pointer;
      }
      &:hover {
        border-left: 6px solid #0465ea;
        padding-left: 23px;
        color: #0465ea;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.1);
        .menu_child {
          visibility: visible;
          opacity: 1;
          left: 280px;
          transition: all 0.2s;
        }
      }

      .menu_child {
        opacity: 0;
        visibility: hidden;
        width: 590px;
        height: 100%;
        z-index: 99;
        position: absolute;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.05);
        border-left: 12px solid #f8f8f8;
        top: 0;
        left: 320px;
        background-color: #fff;
        padding: 10px 0;
        .child_list {
          .child_title {
            font-size: 20px;
            color: #000;
            padding-bottom: 5px;
            display: inline-block;
            margin: 20px 0 12px 45px;
            // color: #0465ea;
            // border-bottom: 2px solid #0465ea;
          }

          .child_tag {
            color: #333333;
            div {
              font-size: 14px;
              text-align: center;
              width: 25%;
              margin: 8px 0;
              border-right: 2px solid #efeef1;
              &:nth-child(4n) {
                border-right: none;
              }
              &:hover {
                color: #0465ea;
              }
            }
          }
        }

        .quick_entry {
          margin: 24px 35px 0;
          padding-top: 30px;
          border-top: 1px solid #000;
          text-align: center;
          color: #333333;
          font-size: 12px;
          > div:hover {
            color: #0465ea;
          }
          img {
            margin-bottom: 12px;
          }
        }
      }
    }
  }

  .MORE {
    background-color: #ebf2ff;
    border-radius: 5px;
    text-align: center;
    width: 180px;
    height: 30px;
    line-height: 30px;
    font-size: 15px;
    font-weight: 500;
    color: #0465ea;
    margin: 0 auto;
  }
}

.nav_menu_fluid {
  width: 100%;
  background-color: #f8f8f8;
  padding: 24px 0 90px;
  .nav_menu {
    width: 1200px;
    height: 560px;
    margin: 0 auto;

    .Popular_law .title,
    .quick .title {
      height: 46px;
      line-height: 46px;
      text-align: center;
      font-size: 22px;
      margin-bottom: 10px;
      color: #fff;
      background-image: url("~assets/home/blue_line_bg.png");
    }

    .banner {
      width: 596px;
      height: 100%;

      .index_swiper {
        width: 596px;
        .swiper_bottom {
          width: 100%;
          height: 34px;
          line-height: 34px;
          background-color: #f8f8f8;
          > div {
            width: 25%;
          }
        }
        .swiper_bottom {
          box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.05);
          .swiper_active {
            background-color: #0465ea;
            color: #fff;
          }
        }
      }

      .recommend_lawyer {
        background-color: #fff;
        margin-top: 12px;
        padding: 0px 9px 10px;
        .item {
          margin-top: 10px;
          position: relative;
          img {
            width: 120px;
            height: 125px;
            object-fit: none;
          }
          .lay_info {
            position: absolute;
            left: 0;
            bottom: 0;
            color: #fff;
            background: rgba(0, 0, 0, 0.4);
            width: 100%;
            height: 24px;
            line-height: 24px;
          }
        }

        .item1 {
          img {
            width: 187px;
          }
        }
      }
    }
    .quick {
      width: 280px;
      height: 100%;
      > .title {
        margin-bottom: 0;
        width: 280px;
      }
      .quick_entry {
        background-color: #fff;
        padding: 0 12px;
        color: #333;
        .current {
          padding: 28px 0 24px;
          font-size: 20px;
          border-bottom: 1px solid #eeeeee;
          img {
            margin-bottom: 18px;
          }
        }
        .fast_list {
          padding: 25px 0;
          > div {
            width: 50%;
            font-size: 14px;
            cursor: pointer;
          }
          .fast_item {
            &:hover {
              color: #0465ea;
              .f_item_icon {
                background-position-y: -29px;
              }
            }
          }
          .f_item_icon {
            width: 29px;
            height: 28px;
            margin: 0 auto 9px;
            transition: all 0.2s;
            background: url("~assets/home/navmenu_f_l.png") no-repeat;
          }

          .f_item_icon1 {
            background-position: -50px 0;
          }

          .f_item_icon2 {
            background-position: -150px 0;
          }

          .f_item_icon3 {
            background-position: -100px 0;
          }

          .f_item_icon4 {
            background-position: 0 0;
          }

          .margin_bottom30 {
            margin-bottom: 30px;
          }
          img {
          }
        }
      }

      .quick_consult {
        width: 280px;
        height: 173px;
        margin-top: 12px;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.1);
        padding: 35px 0;
        background: url("~assets/home/quick_consult_bg.png");

        .qc1 {
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #333333;
        }
        .qc2 {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          margin-top: 13px;
        }
        .qc3btn {
          width: 140px;
          height: 36px;
          line-height: 36px;
          margin: 15px auto 0;
          color: #fff;
          background: #f25618;
          border-radius: 17px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>